import { Provider as TooltipProvider } from "@radix-ui/react-tooltip";
import classcat from "classcat";
import React from "react";

import { Select } from "@touchtech/baselayer-ui";
import { SearchInput, Spinner } from "@touchtech/web-baselayer-ui";

import Pagination from "@is/components/Pagination";
import Tooltip from "@is/components/Tooltip";
import { REGISTRATION_SORT_BY_OPTIONS } from "@is/constants";

import NoResultsPlaceholder from "./NoResultsPlaceholder";
import css from "./SelectStore.module.css";
import StoreListingItem from "./StoreListingItem/StoreListingItem";
import useManageSelectStore from "./hooks/useManageSelectStore";

const SelectStore = () => {
  const {
    stores,
    page,
    totalPages,
    isLoading,
    selectedStore,
    searchTerm,
    country,
    countriesOptions,
    sortBy,
    tableBodyRef,
    showTooltip,
    t,
    handlePageChange,
    handleSelectStore,
    handleSearchChange,
    handleSearchReset,
    handleCountryChange,
    handleSortByChange,
    handleKeyDown,
  } = useManageSelectStore();

  return (
    <TooltipProvider>
      <div className={css.container}>
        <div className={css.filtersContainer}>
          <Tooltip
            showTooltip
            open={showTooltip}
            tooltipContent={
              <span className="text-label-sm">
                {t("Please enter at least 2 characters for your search")}
              </span>
            }
          >
            <div className={css.searchInput}>
              <SearchInput
                sizing="sm"
                onChange={handleSearchChange}
                onReset={handleSearchReset}
                onKeyDown={handleKeyDown}
                width="full"
                value={searchTerm}
                placeholder={t("Search for store name, ID or address")}
              />
            </div>
          </Tooltip>
          <Select
            className={css.select}
            placeholder={t("Country")}
            showSearch
            defaultValue={country}
            options={countriesOptions}
            onChange={handleCountryChange}
            width="100%"
          />
          <Select
            className={css.select}
            placeholder={t("Sort by")}
            defaultValue={sortBy}
            options={REGISTRATION_SORT_BY_OPTIONS()}
            onChange={handleSortByChange}
            width="100%"
          />
        </div>
        <div className={classcat(["text-label-sm", css.tableHeader])}>
          <div className={css.nameColumn}>
            <strong>{t("Store")}</strong>
          </div>
          <div className={css.storeIdColumn}>
            <strong>{t("Store Id")}</strong>
          </div>
          <div className={css.addressColumn}>
            <strong>{t("Address")}</strong>
          </div>
        </div>
        <div ref={tableBodyRef} className={css.tableBody}>
          {isLoading && (
            <div className={css.spinnerContainer}>
              <Spinner />
            </div>
          )}
          {!isLoading &&
            !!stores.length &&
            stores.map((store) => (
              <StoreListingItem
                key={store.id}
                isSelected={store.id === selectedStore?.id}
                store={store}
                onClick={handleSelectStore}
              />
            ))}
          {!isLoading && !stores.length && (
            <NoResultsPlaceholder itemsCount={5} />
          )}
        </div>
        <div className={css.paginationWrapper}>
          {totalPages > 1 && (
            <Pagination
              className={css.pagination}
              pageCount={totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </TooltipProvider>
  );
};

export default SelectStore;
